module.exports = __webpack_public_path__ + "img/step2-b.d2efc049.png";